import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { Form, Formik } from "formik";
import http from "../../../utils/http";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import {
  Backdrop,
  Box,
  Button,
  // Checkbox,
  Chip,
  CircularProgress,
  // Divider,
  Drawer,
  FormControl,
  // FormControlLabel,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  HalfInputWrapper,
  // InputWrapper,
  LabelStyle,
} from "../../Common/styles/form";
import { useParams } from "react-router-dom";
import { commonContainerWrapper } from "../../Common/styles/flex";
import { DrawerForm } from "../../Common/styles/drawer";
// import { CloseRounded } from "@mui/icons-material";
import AddLanguagesDrawer from "./AddLanguagesDrawer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ModalActionButtonStyles } from "../../Common/styles/modal";
import { useAppDispatch } from "../../../Redux/hooks";
import { setStateToggle } from "../../../Redux/reducers/studySlice";
import Loader from "../../Common/assets/Loader";

type Props = {
  canEdit: boolean;
};
const StudyProperties = ({ canEdit }: Props) => {
  const { id: studyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [languages, setLanguages] = useState<any[]>([]);
  const [settings, setSettings] = useState<{
    // twoFactorAuth: boolean;
    // selfRegister: boolean;
    // subjectIdStrategy: string;
    // participantLoginStrategy: string;
    // displayLogicStrategy: string;
  }>({
    // twoFactorAuth: false,
    // selfRegister: false,
    // subjectIdStrategy: "",
    // participantLoginStrategy: "",
    // displayLogicStrategy: "",
  });
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [toggleLoader, setToggleLoader] = useState<boolean>(false);
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let url = `/study/${studyId}/settings/languages`;
        // let url2 = `/study/${studyId}/settings/general`;
        const res: AxiosResponse = await http.get(url);
        // const res2: AxiosResponse = await http.get(url2);
        const resData = res?.data?.data;
        // const resData2 = res2.data.data;
        const languageOptions = resData.map((lang: any) => ({
          languageCode: lang.languageCode,
          languageLabel: lang.languageLabel,
        }));
        // setSettings({
        // twoFactorAuth: resData2.isMfaEnabled,
        // selfRegister: resData2.isParticipantSelfRegistrationEnabled,
        // subjectIdStrategy: resData2.subjectIdStrategy,
        // participantLoginStrategy: resData2.participantLoginStrategy,
        // displayLogicStrategy: resData2.displayLogicStrategy,
        // });
        setLanguages(languageOptions || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [toggleLoader, setLoading, studyId]);

  function refreshPage() {
    setToggleLoader((prev: boolean) => !prev);
  }

  const closeDrawer = () => {
    setOpenDrawer(false);
  };
  async function handleSubmit(values: any) {
    try {
      setSubmitLoader(true);
      // if (values.selfRegister && values.subjectIdStrategy === "free_text") {
      //   toastMessage(
      //     "error",
      //     "Subject Id generation cannot be free text when participant self-registration is enabled!"
      //   );
      //   return;
      // }
      let obj: any = {
        displayLogicStrategy: values.displayLogicStrategy,
        // isMfaEnabled: values.twoFactorAuth,
        // isParticipantSelfRegistrationEnabled: values.selfRegister,
        // subjectIdStrategy: values.subjectIdStrategy,
        // participantLoginStrategy: values.participantLoginStrategy,
      };
      const res: AxiosResponse = await http.patch(
        `/study/${studyId}/settings/display-logic`,
        obj
      );
      toastMessage("success", res.data.message);
      dispatch(setStateToggle());
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setSubmitLoader(false);
    }
  }

  return (
    <>
      {loading ? (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      ) : (
        <Box sx={commonContainerWrapper}>
          <Formik
            initialValues={{
              displayLanguages: languages?.length > 0 ? languages : [],
              // displayLogicStrategy: settings.displayLogicStrategy,
              // subjectIdStrategy:
              //   settings.subjectIdStrategy || "incremental_per_site",
              // twoFactorAuth: settings.twoFactorAuth,
              // selfRegister: settings.selfRegister,
              // participantLoginStrategy:
              //   settings.participantLoginStrategy || "join_code",
            }}
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            {({ values, setFieldValue }: any) => (
              <Form style={DrawerForm}>
                {/* <Box
                  sx={{
                    borderBottom: "1px solid #e0e3eb",
                    width: "100%",
                  }}
                >
                  <FormControl
                    sx={{
                      ...InputWrapper,
                      mb: 2,
                    }}
                  >
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      <FormControlLabel
                        componentsProps={{
                          typography: {
                            sx: { fontSize: 16 },
                          },
                        }}
                        sx={{ fontSize: 16, fontWeight: 500 }}
                        control={
                          <Checkbox
                            value="twoFactorAuth"
                            checked={values?.twoFactorAuth}
                            onChange={() =>
                              setFieldValue(
                                "twoFactorAuth",
                                !values?.twoFactorAuth
                              )
                            }
                          />
                        }
                        label="Allow Two factor Authentication (2FA)"
                      />
                      <Divider />
                      <FormControlLabel
                        componentsProps={{
                          typography: {
                            sx: { fontSize: 16 },
                          },
                        }}
                        sx={{ fontSize: 16, fontWeight: 500 }}
                        control={
                          <Checkbox
                            value="selfRegister"
                            checked={values?.selfRegister}
                            onChange={() =>
                              setFieldValue(
                                "selfRegister",
                                !values?.selfRegister
                              )
                            }
                          />
                        }
                        label="Allow participants to self register for the study"
                      />
                    </Box>
                  </FormControl>
                </Box> */}
                {/* <Box sx={{ mt: 3 }}>
                  <FormControl sx={{ ...HalfInputWrapper, mb: 2 }}>
                    <FormLabel sx={LabelStyle} htmlFor="subjectIdStrategy">
                      Display Logic Strategy
                    </FormLabel>
                    <Select
                      id="displayLogicStrategy"
                      value={values.displayLogicStrategy}
                      onChange={(e) =>
                        setFieldValue("displayLogicStrategy", e.target.value)
                      }
                    >
                      {[
                        {
                          key: "dependencies",
                          label: "Dependencies",
                        },
                        {
                          key: "logic_jumps",
                          label: "Logic Jumps",
                        },
                      ].map((item: any) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box> */}
                {/* <Box sx={{ mt: 3 }}>
                  <FormControl sx={{ ...HalfInputWrapper, mb: 2 }}>
                    <FormLabel sx={LabelStyle} htmlFor="subjectIdStrategy">
                      Generate participant IDs with
                    </FormLabel>
                    <Select
                      id="subjectIdStrategy"
                      value={values.subjectIdStrategy}
                      onChange={(e) =>
                        setFieldValue("subjectIdStrategy", e.target.value)
                      }
                    >
                      {[
                        {
                          key: "incremental_per_site",
                          label: "Incremental per site",
                        },
                        {
                          key: "free_text",
                          label: "Free Text",
                        },
                      ].map((item: any) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box> */}
                {/* <Box sx={{ mt: 3 }}>
                  <FormControl sx={{ ...HalfInputWrapper, mb: 2 }}>
                    <FormLabel sx={LabelStyle} htmlFor="login-strategy">
                      Patient Login Strategy
                    </FormLabel>
                    <Select
                      value={values.participantLoginStrategy}
                      id="login-strategy"
                      onChange={(e) =>
                        setFieldValue(
                          "participantLoginStrategy",
                          e.target.value
                        )
                      }
                    >
                      {[
                        { key: "join_code", label: "Join Code" },
                        { key: "passcode", label: "Passcode" },
                        { key: "password", label: "Password" },
                        // {
                        //   key: "passcode_or_password",
                        //   label: "Passcode or Password",
                        // },
                      ].map((item: any) => (
                        <MenuItem key={item.key} value={item.key}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box> */}
                <Box>
                  <FormControl sx={{ ...HalfInputWrapper, mb: 2 }}>
                    <FormLabel sx={LabelStyle} htmlFor="languages">
                      Languages
                    </FormLabel>

                    <TextField
                      id="languages"
                      value=""
                      placeholder="Select Languages"
                      onClick={(event) => {
                        event.stopPropagation();
                        setOpenDrawer(true);
                      }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            sx={{ cursor: "pointer" }}
                          >
                            <ExpandMoreIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ input: { cursor: "pointer" } }}
                    />
                  </FormControl>
                  {values?.displayLanguages?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        mr: 2,
                        mb: 3,
                        flexWrap: "wrap",
                      }}
                    >
                      {values?.displayLanguages?.map((lang: any) => (
                        <Chip
                          sx={{
                            borderRadius: 1,
                            backgroundColor: "secondary.main",
                          }}
                          key={lang?.languageCode}
                          label={lang?.languageLabel}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
                {/* {canEdit && (
                  <Box sx={{ ...ModalActionButtonStyles, mt: "auto" }}>
                    {!submitLoader ? (
                      <Button variant="contained" type="submit">
                        Save
                      </Button>
                    ) : (
                      <CircularProgress size={25} />
                    )}
                  </Box>
                )} */}
              </Form>
            )}
          </Formik>
          <Drawer open={openDrawer} onClose={closeDrawer} anchor={"right"}>
            <AddLanguagesDrawer
              closeDrawer={closeDrawer}
              refreshPage={refreshPage}
              selectedLanguages={languages}
              canEdit={canEdit}
              studyId={studyId}
            />
          </Drawer>
        </Box>
      )}
    </>
  );
};

export default StudyProperties;
